import { CreditCardIcon as HeroCreditCardIcon } from '@heroicons/react/24/outline';
export const CreditCardIcon = HeroCreditCardIcon;
